import { inject as injectBranding } from '@angular/core';
import { SiteBrandingService } from '../../services/site-branding.service';
import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  OnInit
} from '@angular/core';

import { CommunityPost } from '../../models/app.models';
import { CommunityPostService } from '../../services/community-post.service';
import { ContactSettings, SiteSettingsService } from '../../services/site-setting.service';

@Component({
  selector: 'app-community',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './community.component.html',
  styleUrl: './community.component.css'
})
export class CommunityComponent implements OnInit {
  readonly branding = injectBranding(SiteBrandingService);

  posts: CommunityPost[] = [];

  loading = true;
  loadError = false;

  contactSettings: ContactSettings | null = null;
  constructor(
    private readonly communityPostService: CommunityPostService,
    private readonly changeDetector: ChangeDetectorRef,
    private readonly siteSettingsService:SiteSettingsService
  ) {}

  ngOnInit(): void {
    this.loadPosts();
    this.loadContactSettings();
  }

  private loadContactSettings(): void {
      this.siteSettingsService.getContactSettings().subscribe({
        next: (settings) => {
          this.contactSettings = settings;
          
          this.changeDetector.markForCheck();
        },
        error: (error) => {
          console.error('Failed to load contact settings:', error);
          
          this.changeDetector.markForCheck();
        }
        
      });
    }
    
  get communityEmailLink(): string {
    const email = this.contactSettings?.contactEmail;

    if (!email) {
      return '';
    }

    return `mailto:${email}?subject=${encodeURIComponent('Community Inquiry')}`;
  }

  private loadPosts(): void {
    this.loading = true;
    this.loadError = false;

    this.communityPostService.getPosts().subscribe({
      next: posts => {
        this.posts = [...posts].sort(
            (a, b) =>
            new Date(b.date).getTime() -
            new Date(a.date).getTime()
        );

        this.loading = false;

        this.changeDetector.markForCheck();
        },

      error: error => {
        console.error(
          'Unable to load community posts:',
          error
        );

        this.loading = false;
        this.loadError = true;

        this.changeDetector.markForCheck();
      }
    });
  }
}
